import { render } from "./BoxPlan.vue?vue&type=template&id=45e52c63&scoped=true"
import script from "./BoxPlan.vue?vue&type=script&lang=js"
export * from "./BoxPlan.vue?vue&type=script&lang=js"

import "./BoxPlan.vue?vue&type=style&index=0&id=45e52c63&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-45e52c63"]])

export default __exports__